const getGtmDataLayer = (event, category, action, label) => ({
  event,
  'eventDetails.category': category,
  'eventDetails.action': action,
  'eventDetails.label': label,
});
const pushGtmDataLayer = uuid => ({
  uuid: uuid,
});

export { getGtmDataLayer, pushGtmDataLayer };
